import React from 'react';
import { toast } from 'react-toastify';
import dedent from 'dedent';
import { functions } from '../firebase';
import ProgressButton from './ProgressButton';

const requestPushingAmazonProductToShops = functions.httpsCallable('requestPushingAmazonProductToShops');

export default function ProductUpdateRequestButton({
  items,
  tenant,
  onFinish = () => {},
  children,
  className = '',
  size,
  disabled = false,
}) {
  const onClickUpdateRequest = async () => {
    if (!items || items.length === 0) return;

    const confirmMessage = dedent`
      Amazonの商品ページ内容（画像・タイトル・説明文）に変更があった際にリクエストしてください。
      リクエストすると、ハンロプラスの商品ページ情報を更新します。
      ※Amazon販売価格や卸値の更新ではありません。
    `;

    if (!window.confirm(confirmMessage)) return;

    const itemsToProcess = Array.isArray(items) ? items : [items];
    const productIds = itemsToProcess.map(_ => _.id);

    try {
      await requestPushingAmazonProductToShops({
        tenantId: tenant.id,
        productIds
      });

      toast.success('商品ページ更新をリクエストしました。反映まで２〜３営業日ほどかかります。');
      onFinish();
    } catch (error) {
      console.error('更新リクエストに失敗:', error);
      toast.error('リクエストに失敗しました');
    }
  };

  return (
    <ProgressButton
      className={className}
      size={size}
      color="info"
      disabled={disabled}
      process={onClickUpdateRequest}
    >
      {children || (
        <>
          <span className="fas fa-paper-plane mr-1" />
          商品ページ更新
        </>
      )}
    </ProgressButton>
  );
}
